import {
  VendorDefaultCoding,
  SelectedDimensions,
} from './components/financial/gl-coding/types'

// Mock vendor default configurations
// In production, this would come from backend/tenant configuration
const VENDOR_DEFAULTS: VendorDefaultCoding[] = [
  {
    vendorId: 'officeworks',
    vendorName: 'Officeworks',
    category: 'Office Supplies & Stationery',
    defaultDimensions: {
      Department: '200', // Operations
      'Cost Centre': '2020', // Logistics
      Region: 'GLOBAL',
    },
    description: 'Standard office supplies and stationery purchases',
  },
  {
    vendorId: 'acme-consulting',
    vendorName: 'Acme Consulting Ltd',
    category: 'Professional Services',
    defaultDimensions: {
      Department: '100', // Finance
      'Cost Centre': '1010', // Accounting
      Project: 'P001', // ERP Implementation
      Region: 'GLOBAL',
    },
    description: 'Management and technical consulting services',
  },
  {
    vendorId: 'dell',
    vendorName: 'Dell Technologies',
    category: 'IT Equipment',
    defaultDimensions: {
      Department: '400', // IT
      'Cost Centre': '4010', // Infrastructure
      Project: 'P006', // Infrastructure Upgrade
      Activity: 'A400', // Hardware
      Region: 'GLOBAL',
    },
    description: 'Computer hardware and IT equipment',
  },
  {
    vendorId: 'amazon-business',
    vendorName: 'Amazon Business',
    category: 'General Supplies',
    defaultDimensions: {
      'Business Unit': 'BU01', // Corporate
      Department: '200', // Operations
      'Cost Centre': '2020', // Logistics
      Location: 'LOC-HQ', // Headquarters
      Project: 'BAU', // Business As Usual
      Activity: 'A800', // Office Supplies
      'Product Line': 'PL-ENT', // Enterprise Solutions
      Customer: 'INTERNAL', // Internal Use
      Region: 'GLOBAL',
    },
    description: 'General business supplies and materials',
  },
]

export function useVendorDefaults() {
  const getVendorDefault = (
    vendorId: string,
  ): VendorDefaultCoding | undefined => {
    return VENDOR_DEFAULTS.find((v) => v.vendorId === vendorId)
  }

  const getAllVendorDefaults = (): VendorDefaultCoding[] => {
    return VENDOR_DEFAULTS
  }

  return {
    getVendorDefault,
    getAllVendorDefaults,
  }
}
